import { createSlice } from '@reduxjs/toolkit'
import { endOfYear, format, startOfYear, subYears } from 'date-fns'

export const dashboardUI = createSlice({
  name: 'dashboardUI',
  initialState: {
    group: '',
    grade_level: '',
    date_after: format(subYears(startOfYear(new Date()), 1), 'yyyy-MM-dd'),
    date_before: format(new Date(), 'yyyy-MM-dd'),
    students_count: 0,
    open_avatar: false
  },
  reducers: {
    setGroup: (state, { payload }) => {
      state.group = payload
    },
    setGradeLevel: (state, { payload }) => {
      state.grade_level = payload
    },
    setFromDate: (state, { payload }) => {
      state.date_after = payload
    },
    setToDate: (state, { payload }) => {
      state.date_before = payload
    },
    setStudentsCount: (state, { payload }) => {
      state.students_count = payload
    },
    setOpenAvatar: (state, { payload }) => {
      state.open_avatar = payload
    },
    clearAllFilters: (state: any) => {
      state.group = ''
      state.grade_level = ''
      state.date_after = ''
      state.date_before = ''
    },
  },
})

export const {
  setGroup,
  setGradeLevel,
  setFromDate,
  setToDate,
  setStudentsCount,
  setOpenAvatar,
  clearAllFilters,
} = dashboardUI.actions

export default dashboardUI.reducer
